/**
 * CSS префиксы для компонентов из Antd v5,
 * пока еще не замененные компонентами из TendUI
 */
export const antMigrationPrefix = {
  autocomplete: 'ant-select',
  col: 'ant-col',
  collapse: 'ant-collapse',
  datepicker: 'ant-picker',
  divider: 'ant-divider',
  empty: 'ant-empty',
  form: 'ant-form',
  list: 'ant-list',
  menu: 'ant-menu',
  result: 'ant-result',
  row: 'ant-row',
  skeleton: 'ant-skeleton',
  space: 'ant-space',
  table: 'ant-table',
  tree: 'ant-tree',
  upload: 'ant-upload',
};
